export default {
  DASHBOARD_TRANSACTIONS_API_REQUESTED: 'DASHBOARD_TRANSACTIONS_API_REQUESTED',
  DASHBOARD_TRANSACTIONS_API_SUCCEEDED: 'DASHBOARD_TRANSACTIONS_API_SUCCEEDED',
  DASHBOARD_TRANSACTIONS_API_FAILED: 'DASHBOARD_TRANSACTIONS_API_FAILED',
};
